module.exports = __webpack_public_path__ + "img/uf_stamp.e822e3bb.jpg";